module.exports = __webpack_public_path__ + "static/media/virus (11).2eb5ee62.png";